// extracted by mini-css-extract-plugin
export default {"headerActivity":"headerActivity_jmgQy","activity-box":"activity-box_xEGfJ","activityBox":"activity-box_xEGfJ","icon":"icon_i37C6","btn":"btn_dBIkI"};